import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './css/sprite_icons.css';
import './css/lightbox.css';
import './css/multi-carousel.css';
import App from './App';
import './Config';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('cc_wrapper')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
